/* Read confirmed Shopify totals; this module never recalculates a payable discount. */
(function () {
  'use strict';
  function eligible(item, excluded) {
    return !!item && !(excluded || []).map(String).includes(String(item.product_id)) &&
      !/vip|exclusivo/i.test(item.handle || '') && Number(item.final_price ?? item.price ?? 1) > 0;
  }
  function summary(cart, excluded) {
    const items = cart.items || [];
    return { quantity: Number(cart.item_count) || 0,
      eligibleQuantity: items.filter(i => eligible(i, excluded)).reduce((n,i) => n + Number(i.quantity || 0),0),
      total: Number(cart.total_price) || 0, original: Number(cart.original_total_price) || 0,
      savings: Math.max(0, Number(cart.original_total_price || 0) - Number(cart.total_price || 0)) };
  }
  function action(url, method, origin) {
    try { const u = new URL(url, origin); return u.origin === origin && /^(POST|PUT)$/i.test(method) && /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(u.pathname) ? u.pathname.match(/\/(add|change|update|clear)(?:\.js)?\/?$/)[1] : ''; } catch (_) { return ''; }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { eligible, summary, action };
  if (typeof window === 'undefined' || window.HolyCartConsistency) return;
  window.HolyCartConsistency = { eligible, summary, exclusions() {
    try { const config = document.querySelector('[data-hs-cart-exclusions]'); return config ? JSON.parse(config.textContent) : JSON.parse(document.querySelector('[data-hs-service-config]')?.textContent || '{}').excluded || []; } catch (_) { return []; }
  }};
  function analyticsAllowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  // Persist only a consented home exposure; no customer identifiers or campaign overrides.
  const homeKey = 'holy_home_exposure_v1';
  function homeContext() {
    const theme = window.Shopify?.theme || {};
    const preview = theme.role !== 'main' || window.Shopify?.designMode === true;
    const visible = document.querySelector('[data-hs-home-variant]')?.dataset.hsHomeVariant;
    const valid = value => ['compra-direta-v1','holy-antiga','holy-4.7.3'].includes(value);
    const fallback = {variant:valid(visible) ? visible : 'unassigned', preview};
    if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function') return fallback;
    if (!analyticsAllowed()) {
      try { window.sessionStorage.removeItem(homeKey); } catch (_) {}
      return fallback;
    }
    try {
      let context = JSON.parse(window.sessionStorage.getItem(homeKey) || 'null');
      if (!context || context.theme !== theme.id || context.preview !== preview ||
          !valid(context.variant) || !Number.isFinite(context.at) || context.at > Date.now() || Date.now() - context.at > 1800000) context = null;
      // A deliberate alternate-home preview replaces the QA exposure.
      if (valid(visible) && (!context || (preview && context.variant !== visible)))
        context = {variant:visible,preview,theme:theme.id,at:Date.now()};
      if (context) { window.sessionStorage.setItem(homeKey,JSON.stringify(context)); return context; }
    } catch (_) { /* Storage blocked: the purchase flow still works. */ }
    return fallback;
  }
  window.HolyCartConsistency.decorateCheckout = function(url) {
    if (!analyticsAllowed()) return url;
    const context = homeContext();
    if (context.variant === 'unassigned') return url;
    try {
      const target = new URL(url);
      if (target.protocol !== 'https:' || target.hostname !== 'seguro.holyfoods.com.br') return url;
      target.searchParams.set('metadata[holy_experiment]','holy-home-2026-09');
      target.searchParams.set('metadata[holy_home]',context.variant);
      target.searchParams.set('metadata[holy_theme]',String(window.Shopify?.theme?.id || ''));
      target.searchParams.set('metadata[holy_preview]',context.preview ? '1' : '0');
      return target.href;
    } catch (_) { return url; }
  };

  // Capture the home before navigating to a product; no new analytics events.
  let homePrivacyLoading = false;
  function captureHome() {
    homeContext();
    if (!window.Shopify?.customerPrivacy && !homePrivacyLoading && typeof window.Shopify?.loadFeatures === 'function') {
      homePrivacyLoading = true;
      try { window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
        if (!error && window.Shopify?.customerPrivacy) homeContext();
      }); } catch (_) { /* Checkout still works without analytics consent API. */ }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',captureHome,{once:true});
  else captureHome();
  window.addEventListener('load',captureHome,{once:true});
  document.addEventListener('visitorConsentCollected',captureHome);

  let timer;
  function changed(kind, data) {
    if (data && Number(data.status) >= 400) return;
    clearTimeout(timer);
    timer = setTimeout(() => window.dispatchEvent(new CustomEvent('cart-change', {detail:{source:'confirmed-request', action:kind}})),80);
    if (kind === 'add') {
      window.dispatchEvent(new CustomEvent('hs:cart-added'));
      if (window.matchMedia('(min-width: 1025px)').matches) {
        window.dispatchEvent(new CustomEvent('show-cart', { detail: true }));
      }
    }
  }
  const nativeFetch = window.fetch;
  window.fetch = function(input, init) {
    const kind = action(typeof input === 'string' || input instanceof URL ? String(input) : input?.url, init?.method || input?.method || 'GET', location.origin);
    const request = nativeFetch.apply(this, arguments);
    if (kind) request.then(response => {
      if (!response.ok) return;
      response.clone().json().then(data => changed(kind,data)).catch(() => {});
    }, () => {});
    return request;
  };
  const open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
  const pending = new WeakMap();
  XMLHttpRequest.prototype.open = function(method,url) { pending.set(this,action(url,method,location.origin)); return open.apply(this,arguments); };
  XMLHttpRequest.prototype.send = function() {
    const kind = pending.get(this);
    if (kind) this.addEventListener('load',function() {
      if (this.status < 200 || this.status >= 300) return;
      try { changed(kind,this.responseType === 'json' ? this.response : JSON.parse(this.responseText)); } catch (_) {}
    },{once:true});
    return send.apply(this,arguments);
  };
})();
